export default __webpack_public_path__ + "static/media/imgLoja04.bf3630dd.png";